import React, { type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilCallback } from 'recoil'

import { Link } from 'mailup-web-components'

import { panelEditRecipientOpenCallback } from 'Pages/RecipientsList/recoil/callbacks/recipient'

interface AddRecipientExistingProps {
  idRecipient: number
}

const AddRecipientExisting: FC<AddRecipientExistingProps> = ({
  idRecipient,
}) => {
  const intl = useIntl()

  const openRecipient = useRecoilCallback(panelEditRecipientOpenCallback, [])

  const handleClick = (): void => {
    void openRecipient(idRecipient)
  }

  return (
    <p>
      {intl.formatMessage(
        { id: 'Load.RecipientsList.AddRecipientExistingError' },
        {
          link: (chunks) => (
            <Link
              data-mu-test="add-recipient-existing__open-existing"
              onClick={handleClick}
            >
              {chunks}
            </Link>
          ),
        },
      )}
    </p>
  )
}

export default AddRecipientExisting
